function OffenderTimeOutSchedule(aSchedule) {
    this.__type = 'OffenderTimeOutSchedule:www.veritracks.com';
    this.Id = -1;
    this.SecondId = -1;
    this.Reason = '';
    this.EnrolleeId = -1;
    this.StartDate = ' ';
    this.StartTime = '';
    this.StopTime = '';
    this.IsActive = true;
    this.IsRecurring = true;
    this.ScheduleTypeId = -1;
    this.EntityId = -1;
    this.ZoneScheduleType = -1;
    this.TransactionId = '';
    this.TitleUpdatedFlag = 0;
    if (aSchedule) {
        this.Id = aSchedule.Id;
        this.Reason = aSchedule.Name;
        this.EnrolleeId = aSchedule.EnrolleeId;
        this.IsActive = convertBoolToInteger(aSchedule.IsActive);
        this.IsRecurring = convertBoolToInteger(aSchedule.IsRecurring);
        this.ScheduleTypeId = aSchedule.ScheduleType;
        this.EntityId = aSchedule.EntityId;
        this.ZoneScheduleType = aSchedule.ZoneScheduleType;
        this.TransactionId = moment().format("YYYYMMDDHHmmss");
        this.TitleUpdatedFlag = (aSchedule.TitleUpdatedFlag ? 1 : 0);
    }
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderTimeOutSchedule;
}